/**
 * Do not edit directly
 * Generated on Mon, 04 Dec 2023 11:32:39 GMT
 */

export const rvoColorLogoblauw = "#154273";
export const rvoColorHemelblauw = "#007bc7";
export const rvoColorHemelblauwTint1 = "#b2d7ee";
export const rvoColorHemelblauwTint2 = "#d9ebf7";
export const rvoColorLichtblauw = "#8fcae7";
export const rvoColorLichtblauwTint1 = "#ddeff8";
export const rvoColorLichtblauwTint2 = "#eef7fb";
export const rvoColorDonkerblauw = "#01689b";
export const rvoColorDonkerblauwShade1 = "#01496D"; // 30% black (shade) of 'donkerblauw'
export const rvoColorOranje = "#e17000";
export const rvoColorOranjeTint1 = "#f6d4b2";
export const rvoColorOranjeTint2 = "#fbead9";
export const rvoColorGroen = "#39870c";
export const rvoColorGroenTint1 = "#c3dbb6";
export const rvoColorGroenTint2 = "#e1eddb";
export const rvoColorDonkergroen = "#275e08";
export const rvoColorDonkergeel = "#ffb612";
export const rvoColorDonkergeelTint1 = "#ffe9b7";
export const rvoColorDonkergeelTint2 = "#fff4dc";
export const rvoColorRood = "#d51b1e";
export const rvoColorRoodTint1 = "#f2bfbb";
export const rvoColorRoodShade1 = "#4d0a0b";
export const rvoColorRoodTint2 = "#f9dfdd";
export const rvoColorGrijs1 = "#f3f3f3";
export const rvoColorGrijs2 = "#e6e6e6";
export const rvoColorGrijs3 = "#cccccc";
export const rvoColorGrijs4 = "#b4b4b4";
export const rvoColorGrijs5 = "#999999";
export const rvoColorGrijs6 = "#696969";
export const rvoColorGrijs7 = "#535353";
export const rvoColorZwart = "#000000";
export const rvoColorWit = "#ffffff";
export const rvoSize3xs = "2px";
export const rvoSize2xs = "4px";
export const rvoSizeXs = "8px";
export const rvoSizeSm = "12px";
export const rvoSizeMd = "16px";
export const rvoSizeLg = "18px";
export const rvoSizeXl = "24px";
export const rvoSize2xl = "32px";
export const rvoSize3xl = "64px";
export const rvoSize4xl = "128px";
export const rvoSpace3xs = "2px";
export const rvoSpace2xs = "4px";
export const rvoSpaceXs = "8px";
export const rvoSpaceSm = "12px";
export const rvoSpaceMd = "16px";
export const rvoSpaceLg = "18px";
export const rvoSpaceXl = "24px";
export const rvoSpace2xl = "32px";
export const rvoSpace3xl = "64px";
export const rvoSpace4xl = "128px";
export const rvoFontSansSerifFontFamily = "'RijksoverheidSansWebText'";
export const rvoFontSansSerifFallbackFontFamily = "'Calibri', 'Verdana', 'Arial', sans-serif";
export const rvoFontSerifFontFamily = "'RijksoverheidSerifWeb'";
export const rvoFontSerifFallbackFontFamily = "'Times New Roman', serif";
export const rvoFontSize2xs = "0.625rem";
export const rvoFontSizeXs = "0.75rem";
export const rvoFontSizeSm = "0.875rem";
export const rvoFontSizeMd = "1rem";
export const rvoFontSizeLg = "1.125rem";
export const rvoFontSizeXl = "1.25rem";
export const rvoFontSize2xl = "1.5rem";
export const rvoFontSize3xl = "2rem";
export const rvoFontSize4xl = "3rem";
export const rvoFontWeightNormal = "400";
export const rvoFontWeightBold = "700";
export const rvoLineHeightSm = "125%";
export const rvoLineHeightMd = "150%";
export const rvoLineHeightLg = "175%";
export const rvoRootFontSize = "100%";
export const rvoDocumentBackgroundColor = "#ffffff";
export const rvoDocumentColor = "#000000";
export const rvoDocumentFontFamily = "'RijksoverheidSansWebText'";
export const rvoDocumentFontSize = "18px";
export const rvoDocumentLineHeight = "150%";
export const rvoFocusOutlineOffset = "2px";
export const rvoLayoutMaxWidthSm = "600px";
export const rvoLayoutMaxWidthMd = "900px";
export const rvoLayoutMaxWidthLg = "1200px";
export const rvoAccordionGrijsBackgroundColor = "#f3f3f3";
export const rvoAccordionBorderColor = "#b2d7ee";
export const rvoAccordionItemIconPaddingBlockStart = "8px";
export const rvoAccordionItemSummaryPaddingBlockEnd = "16px";
export const rvoAccordionItemSummaryPaddingBlockStart = "16px";
export const rvoAccordionItemSummaryPaddingInlineEnd = "16px";
export const rvoAccordionItemSummaryPaddingInlineStart = "16px";
export const rvoAccordionItemTeaserFontSize = "1rem";
export const rvoAccordionItemTeaserFontStyle = "italic";
export const rvoAccordionItemTeaserFontWeight = "400";
export const rvoAccordionItemTeaserPaddingBlockEnd = "0";
export const rvoAccordionItemTeaserPaddingBlockStart = "4px";
export const rvoAccordionItemTeaserPaddingInlineEnd = "0";
export const rvoAccordionItemTeaserPaddingInlineStart = "24px";
export const rvoAccordionItemContentPaddingBlockEnd = "24px";
export const rvoAccordionItemContentPaddingBlockStart = "0";
export const rvoAccordionItemContentPaddingInlineEnd = "24px";
export const rvoAccordionItemContentPaddingInlineStart = "calc(24px + 18px)";
export const rvoAccordionItemBorderBottom = "#cccccc";
export const rvoAlertGap = "calc(4px + 8px)";
export const rvoAlertPaddingBlockEnd = "16px";
export const rvoAlertPaddingBlockStart = "16px";
export const rvoAlertPaddingInlineEnd = "16px";
export const rvoAlertPaddingInlineStart = "16px";
export const rvoAlertFieldsetMargin = "-24px";
export const rvoAlertLineHeight = "150%";
export const rvoAlertInfoBackgroundColor = "#d9ebf7";
export const rvoAlertWarningBackgroundColor = "#fff4dc";
export const rvoAlertErrorBackgroundColor = "#f9dfdd";
export const rvoAlertSuccessBackgroundColor = "#e1eddb";
export const rvoBreadcrumbsSmFontSize = "0.875rem";
export const rvoBreadcrumbsMdFontSize = "1rem";
export const rvoBreadcrumbsLgFontSize = "1.125rem";
export const rvoButtonGroupPaddingBlockEnd = "16px";
export const rvoButtonGroupPaddingBlockStart = "0";
export const rvoButtonGroupPaddingInlineEnd = "16px";
export const rvoButtonGroupPaddingInlineStart = "16px";
export const rvoCheckboxSize = "24px";
export const rvoCheckboxIconSize = "16px";
export const rvoCheckboxIconColor = "#ffffff";
export const rvoCheckboxBackgroundColor = "#ffffff";
export const rvoCheckboxBorderWidth = "2px";
export const rvoCheckboxBorderColor = "#000000";
export const rvoCheckboxCheckedBackgroundColor = "#007bc7";
export const rvoCheckboxHoverBackgroundColor = "#01689b";
export const rvoCheckboxHoverBorderColor = "#007bc7";
export const rvoCheckboxDisabledBorderColor = "#cccccc";
export const rvoCheckboxDisabledBackgroundColor = "#ffffff";
export const rvoCheckboxDisabledColor = "#cccccc";
export const rvoDataListBorderWidth = "1px";
export const rvoDataListBorderStyle = "solid";
export const rvoDataListBorderColor = "#b4b4b4";
export const rvoDataListDtBorderTopWidth = "1px";
export const rvoDataListDtBorderTopStyle = "solid";
export const rvoDataListDtBorderTopColor = "#b4b4b4";
export const rvoDataListDtFontWeight = "700";
export const rvoDataListDtPaddingBlockEnd = "0";
export const rvoDataListDtPaddingBlockStart = "8px";
export const rvoDataListDtPaddingInlineEnd = "8px";
export const rvoDataListDtPaddingInlineStart = "8px";
export const rvoDataListDdMarginInlineStart = "0";
export const rvoDataListDdPaddingBlockEnd = "8px";
export const rvoDataListDdPaddingBlockStart = "0";
export const rvoDataListDdPaddingInlineEnd = "16px";
export const rvoDataListDdPaddingInlineStart = "16px";
export const rvoDataListBreakpointSmDtPaddingBlockEnd = "8px";
export const rvoDataListBreakpointSmDtPaddingBlockStart = "8px";
export const rvoDataListBreakpointSmDtPaddingInlineEnd = "16px";
export const rvoDataListBreakpointSmDtPaddingInlineStart = "16px";
export const rvoDataListBreakpointSmDdBorderTopWidth = "1px";
export const rvoDataListBreakpointSmDdBorderTopStyle = "solid";
export const rvoDataListBreakpointSmDdBorderTopColor = "#b4b4b4";
export const rvoDataListBreakpointSmDdBorderLeftWidth = "1px";
export const rvoDataListBreakpointSmDdBorderLeftStyle = "solid";
export const rvoDataListBreakpointSmDdBorderLeftColor = "#b4b4b4";
export const rvoDataListBreakpointSmDdPaddingBlockEnd = "8px";
export const rvoDataListBreakpointSmDdPaddingBlockStart = "8px";
export const rvoDataListBreakpointSmDdPaddingInlineEnd = "16px";
export const rvoDataListBreakpointSmDdPaddingInlineStart = "16px";
export const rvoExpandableTextPaddingBlockEnd = "0";
export const rvoExpandableTextPaddingBlockStart = "0";
export const rvoExpandableTextSummaryColor = "#007bc7";
export const rvoExpandableTextSummaryFontWeight = "700";
export const rvoExpandableTextSummaryGap = "4px";
export const rvoExpandableTextSummaryLineHeight = "150%";
export const rvoExpandableTextSummaryIconBackgroundColor = "#007bc7";
export const rvoExpandableTextDetailsPaddingBlockEnd = "8px";
export const rvoExpandableTextDetailsPaddingBlockStart = "4px";
export const rvoFileInputColor = "#007bc7";
export const rvoFileInputFontWeight = "700";
export const rvoFileInputPaddingBlockEnd = "10px";
export const rvoFileInputFocusOutlineOffset = "0";
export const rvoFooterBackgroundColor = "#007bc7";
export const rvoFooterColor = "#ffffff";
export const rvoFooterPaddingInlineEnd = "18px";
export const rvoFooterPaddingInlineStart = "18px";
export const rvoFooterColumnGap = "64px";
export const rvoFooterColumnItemGap = "8px";
export const rvoFooterColumnMarginBlockEnd = "0";
export const rvoFooterColumnMarginBlockStart = "0";
export const rvoFooterColumnPaddingBlockEnd = "32px";
export const rvoFooterColumnPaddingBlockStart = "32px";
export const rvoFooterColumnPaddingInlineEnd = "0";
export const rvoFooterColumnPaddingInlineStart = "0";
export const rvoFooterColumnLabelColor = "#ffffff";
export const rvoFooterColumnLabelMarginBlockEnd = "0";
export const rvoFooterColumnLabelMarginBlockStart = "0";
export const rvoFooterColumnItemlinkColor = "#ffffff";
export const rvoFooterColumnItemlinkFontWeight = "400";
export const rvoFooterColumnItemlinkHoverColor = "#ffffff";
export const rvoFooterColumnItemlinkHoverFontWeight = "400";
export const rvoFooterColumnItemlinkFocusBackgroundColor = "#01689b";
export const rvoFooterColumnItemlinkFocusColor = "#ffffff";
export const rvoFooterColumnItemlinkFocusFontWeight = "400";
export const rvoFormFeedbackLineHeight = "150%";
export const rvoFormFeedbackErrorColor = "#d51b1e";
export const rvoFormFeedbackErrorFontWeight = "700";
export const rvoFormFieldLabelFontWeight = "700";
export const rvoFormFieldsetBackgroundColor = "#f3f3f3";
export const rvoFormFieldsetPaddingBlockEnd = "calc(8px + 16px)";
export const rvoFormFieldsetPaddingBlockStart = "calc(8px + 8px)";
export const rvoFormFieldsetPaddingInlineEnd = "calc(8px + 16px)";
export const rvoFormFieldsetPaddingInlineStart = "calc(8px + 16px)";
export const rvoHeading1LineHeight = "125%";
export const rvoIconXsWidth = "8px";
export const rvoIconXsHeight = "8px";
export const rvoIconSmWidth = "calc(4px + 8px)";
export const rvoIconSmHeight = "calc(4px + 8px)";
export const rvoIconMdWidth = "16px";
export const rvoIconMdHeight = "16px";
export const rvoIconLgWidth = "18px";
export const rvoIconLgHeight = "18px";
export const rvoIconXlWidth = "24px";
export const rvoIconXlHeight = "24px";
export const rvoIcon2xlWidth = "32px";
export const rvoIcon2xlHeight = "32px";
export const rvoIcon3xlWidth = "64px";
export const rvoIcon3xlHeight = "64px";
export const rvoIcon4xlWidth = "128px";
export const rvoIcon4xlHeight = "128px";
export const rvoLabelColor = "#000000";
export const rvoLabelFontSize = "0.875rem";
export const rvoLabelFontWeight = "700";
export const rvoLabelSmFontSize = "0.875rem";
export const rvoLabelSmFontWeight = "400";
export const rvoLabelOptionalColor = "#000000";
export const rvoLabelOptionalContent = "' (optioneel)'";
export const rvoLabelOptionalFontSize = "0.75rem";
export const rvoLabelOptionalFontWeight = "400";
export const rvoLabelRequiredColor = "#d51b1e";
export const rvoLabelRequiredContent = "' *'";
export const rvoLabelRequiredFontSize = "0.75rem";
export const rvoLabelRequiredFontWeight = "400";
export const rvoLinkColor = "#007bc7";
export const rvoLinkTextDecoration = "underline";
export const rvoLinkTextDecorationThickness = "1px";
export const rvoLinkTextUnderlineOffset = "2px";
export const rvoLinkFontWeight = "700";
export const rvoLinkIconBackgroundColor = "#007bc7";
export const rvoLinkHoverColor = "#01689b";
export const rvoLinkHoverTextDecorationThickness = "2px";
export const rvoLinkHoverFontWeight = "700";
export const rvoLinkHoverIconBackgroundColor = "#01689b";
export const rvoLinkActiveColor = "#01689b";
export const rvoLinkActiveFontWeight = "700";
export const rvoLinkActiveIconBackgroundColor = "#01689b";
export const rvoLinkActiveTextDecorationThickness = "2px";
export const rvoLinkFocusBackgroundColor = "#d9ebf7";
export const rvoLinkFocusColor = "#000000";
export const rvoLinkFocusFontWeight = "700";
export const rvoLinkFocusIconBackgroundColor = "#000000";
export const rvoLinkFocusTextDecorationThickness = "3px";
export const rvoLogoFontFamily = "'RijksoverheidSerifWeb'";
export const rvoLogoFontSize = "16px";
export const rvoLogoEmblemBackgroundColor = "#154273";
export const rvoLogoEmblemColor = "#ffffff";
export const rvoLogoSubtitleMaxInlineSize = "200px";
export const rvoOrderedListMarginBlockEnd = "16px";
export const rvoOrderedListItemPaddingInlineStart = "0";
export const rvoOrderedListPaddingInlineStart = "40px";
export const rvoProgressTrackerMaxWidth = "600px";
export const rvoProgressTrackerStepHeight = "36px";
export const rvoProgressTrackerStepLabelPadding = "calc(8px + 32px)";
export const rvoProgressTrackerStepLinkPaddingBlockEnd = "2px";
export const rvoProgressTrackerStepLineWidth = "28px";
export const rvoProgressTrackerStepLineHeight = "40px";
export const rvoProgressTrackerStepLineTop = "20px";
export const rvoProgressTrackerStepLineLeft = "0";
export const rvoProgressTrackerStepStartFontSize = "1.25rem";
export const rvoProgressTrackerStepStartFontWeight = "700";
export const rvoProgressTrackerStepEndFontSize = "0.875rem";
export const rvoProgressTrackerStepEndFontWeight = "700";
export const rvoProgressTrackerStepSmIconBackgroundPosition = "9px center";
export const rvoProgressTrackerStepSmLineLeft = "6px";
export const rvoProgressTrackerSubstepBlockPadding = "8px";
export const rvoRadioButtonLabelDisabledColor = "#cccccc";
export const rvoRadioButtonHoverBorderColor = "#007bc7";
export const rvoRadioButtonCheckedBackground = "radial-gradient(circle, #007bc7 45%, #ffffff 50%)";
export const rvoSelectIconBackgroundColor = "#007bc7";
export const rvoSelectIconColor = "#ffffff";
export const rvoSelectOutlineOffset = "0";
export const rvoSelectPaddingBlockEnd = "8px";
export const rvoSelectPaddingBlockStart = "10px";
export const rvoSelectPaddingInlineEnd = "calc(4px + 32px)";
export const rvoSelectPaddingInlineStart = "calc(4px + 8px)";
export const rvoSkipLinkBackgroundColor = "#007bc7";
export const rvoSkipLinkFontSize = "18px";
export const rvoSkipLinkPaddingBlockStart = "12px";
export const rvoSkipLinkPaddingBlockEnd = "12px";
export const rvoSkipLinkFontWeight = "400";
export const rvoSkipLinkColor = "#ffffff";
export const rvoStatusiconBevestigingBackgroundColor = "#39870c";
export const rvoStatusiconFoutmeldingBackgroundColor = "#d51b1e";
export const rvoStatusiconWaarschuwingBackgroundColor = "#ffb612";
export const rvoStatusiconInfoBackgroundColor = "#007bc7";
export const rvoCaptionFontSize = "1.125rem";
export const rvoCaptionPaddingBlockEnd = "16px";
export const rvoTableHeaderBackgroundColor = "#f3f3f3";
export const rvoTableHeaderColor = "#535353";
export const rvoTableHeaderFontWeight = "400";
export const rvoTableHeaderPaddingBlockEnd = "8px";
export const rvoTableHeaderPaddingBlockStart = "8px";
export const rvoTableHeaderPaddingInlineEnd = "16px";
export const rvoTableHeaderPaddingInlineStart = "16px";
export const rvoTableHeaderSortableHoverBackgroundColor = "#e6e6e6";
export const rvoTableHeaderSortableFocusBackgroundColor = "#e6e6e6";
export const rvoTableCellBorderBottomWidth = "0.05rem";
export const rvoTableCellBorderBottomStyle = "solid";
export const rvoTableCellBorderBottomColor = "#cccccc";
export const rvoTableCellPaddingBlockEnd = "8px";
export const rvoTableCellPaddingBlockStart = "8px";
export const rvoTableCellPaddingInlineEnd = "16px";
export const rvoTableCellPaddingInlineStart = "16px";
export const rvoTagBorderRadius = "3px";
export const rvoTagPaddingBlockEnd = "4px";
export const rvoTagPaddingBlockStart = "4px";
export const rvoTagPaddingInlineEnd = "12px";
export const rvoTagPaddingInlineStart = "12px";
export const rvoTagPaddingInlineEndWithIcon = "8px";
export const rvoTagPaddingInlineStartWithIcon = "8px";
export const rvoTagDefaultBackgroundColor = "#b4b4b4";
export const rvoTagDefaultColor = "#000000";
export const rvoTagDefaultIconColor = "#000000";
export const rvoTagDefaultHoverBackgroundColor = "#cccccc";
export const rvoTagDefaultHoverColor = "#000000";
export const rvoTagDefaultHoverIconColor = "#000000";
export const rvoTagDefaultActiveBackgroundColor = "#e6e6e6";
export const rvoTagDefaultActiveColor = "#000000";
export const rvoTagDefaultActiveIconColor = "#000000";
export const rvoTagInfoBackgroundColor = "#8fcae7";
export const rvoTagInfoColor = "#000000";
export const rvoTagInfoIconColor = "#007bc7";
export const rvoTagInfoHoverBackgroundColor = "#ddeff8";
export const rvoTagInfoHoverColor = "#000000";
export const rvoTagInfoHoverIconColor = "#007bc7";
export const rvoTagInfoActiveBackgroundColor = "#eef7fb";
export const rvoTagInfoActiveColor = "#000000";
export const rvoTagInfoActiveIconColor = "#007bc7";
export const rvoTagWarningBackgroundColor = "#ffb612";
export const rvoTagWarningColor = "#000000";
export const rvoTagWarningIconColor = "#000000";
export const rvoTagWarningHoverBackgroundColor = "#ffe9b7";
export const rvoTagWarningHoverColor = "#000000";
export const rvoTagWarningHoverIconColor = "#ffb612";
export const rvoTagWarningActiveBackgroundColor = "#fff4dc";
export const rvoTagWarningActiveColor = "#000000";
export const rvoTagWarningActiveIconColor = "#ffb612";
export const rvoTagErrorBackgroundColor = "#d51b1e";
export const rvoTagErrorColor = "#ffffff";
export const rvoTagErrorIconColor = "#ffffff";
export const rvoTagErrorHoverBackgroundColor = "#f2bfbb";
export const rvoTagErrorHoverColor = "#000000";
export const rvoTagErrorHoverIconColor = "#d51b1e";
export const rvoTagErrorActiveBackgroundColor = "#f9dfdd";
export const rvoTagErrorActiveColor = "#000000";
export const rvoTagErrorActiveIconColor = "#d51b1e";
export const rvoTagSuccessBackgroundColor = "#39870c";
export const rvoTagSuccessColor = "#ffffff";
export const rvoTagSuccessIconColor = "#ffffff";
export const rvoTagSuccessHoverBackgroundColor = "#c3dbb6";
export const rvoTagSuccessHoverColor = "#000000";
export const rvoTagSuccessHoverIconColor = "#39870c";
export const rvoTagSuccessActiveBackgroundColor = "#e1eddb";
export const rvoTagSuccessActiveColor = "#000000";
export const rvoTagSuccessActiveIconColor = "#39870c";
export const rvoTextboxOutlineOffset = "0";
export const rvoTextboxInvalidFocusBorderColor = "#000000";
export const rvoTextboxInvalidFocusOutlineColor = "#d51b1e";
export const rvoTextboxXsWidth = "64px";
export const rvoTextboxSmWidth = "128px";
export const rvoTextboxMdWidth = "calc(128px * 2)";
export const rvoTopnavFontFamily = "'RijksoverheidSansWebText'";
export const rvoTopnavSmFontSize = "0.875rem";
export const rvoTopnavMdFontSize = "1rem";
export const rvoTopnavLgFontSize = "1.125rem";
export const rvoTopnavLinkPaddingBlockStart = "16px";
export const rvoTopnavLinkPaddingBlockEnd = "16px";
export const rvoTopnavLinkPaddingInlineStart = "16px";
export const rvoTopnavLinkPaddingInlineEnd = "16px";
export const rvoTopnavItemActiveBackgroundColor = "#01689b";
export const rvoTopnavItemActiveFontWeight = "700";
export const rvoTopnavSubmenuBackgroundColor = "#01689b";
export const rvoTopnavSubmenuPaddingInlineStart = "24px";
export const rvoUnorderedListMarginBlockStart = "0";
export const rvoUnorderedListMarginBlockEnd = "16px";
export const rvoUnorderedListItemPaddingInlineStart = "8px";
export const rvoUnorderedListPaddingInlineStart = "32px";
export const utrechtActionActivateCursor = "pointer";
export const utrechtActionBusyCursor = "wait";
export const utrechtActionDisabledCursor = "not-allowed";
export const utrechtActionSubmitCursor = "pointer";
export const utrechtFocusOutlineColor = "#007bc7";
export const utrechtFocusOutlineOffset = "3px";
export const utrechtFocusOutlineStyle = "solid";
export const utrechtFocusOutlineWidth = "3px";
export const utrechtButtonRvoTertiaryActionBackgroundColor = "transparent";
export const utrechtButtonRvoTertiaryActionBorderWidth = "0";
export const utrechtButtonRvoTertiaryActionColor = "#007bc7";
export const utrechtButtonRvoTertiaryActionFontWeight = "700";
export const utrechtButtonRvoTertiaryActionActiveColor = "#01689b";
export const utrechtButtonRvoTertiaryActionHoverColor = "#01689b";
export const utrechtButtonRvoTertiaryActionHoverTextDecoration = "underline";
export const utrechtButtonRvoTertiaryActionDisabledBackgroundColor = "transparent";
export const utrechtButtonRvoTertiaryActionDisabledColor = "#cccccc";
export const utrechtButtonRvoTertiaryActionFocusColor = "#007bc7";
export const utrechtButtonRvoQuaternaryActionBackgroundColor = "#39870c";
export const utrechtButtonRvoQuaternaryActionBorderWidth = "0";
export const utrechtButtonRvoQuaternaryActionColor = "#ffffff";
export const utrechtButtonRvoQuaternaryActionActiveBackgroundColor = "#275e08";
export const utrechtButtonRvoQuaternaryActionActiveColor = "#ffffff";
export const utrechtButtonRvoQuaternaryActionHoverBackgroundColor = "#275e08";
export const utrechtButtonRvoQuaternaryActionHoverColor = "#ffffff";
export const utrechtButtonRvoQuaternaryActionDisabledBorderColor = "#e6e6e6";
export const utrechtButtonRvoQuaternaryActionDisabledBackgroundColor = "#e6e6e6";
export const utrechtButtonRvoQuaternaryActionDisabledColor = "#cccccc";
export const utrechtButtonRvoQuaternaryActionFocusBackgroundColor = "#39870c";
export const utrechtButtonRvoQuaternaryActionFocusBorderWidth = "0";
export const utrechtButtonRvoQuaternaryActionFocusColor = "#ffffff";
export const utrechtButtonRvoXsFontSize = "0.875rem";
export const utrechtButtonRvoXsFontWeight = "400";
export const utrechtButtonRvoXsPaddingBlockStart = "4px";
export const utrechtButtonRvoXsPaddingBlockEnd = "4px";
export const utrechtButtonRvoXsPaddingInlineStart = "calc(8px + 4px)";
export const utrechtButtonRvoXsPaddingInlineEnd = "calc(8px + 4px)";
export const utrechtButtonRvoXsMinBlockSize = "auto";
export const utrechtButtonRvoSmFontSize = "1rem";
export const utrechtButtonRvoSmPaddingBlockStart = "4px";
export const utrechtButtonRvoSmPaddingBlockEnd = "4px";
export const utrechtButtonRvoSmPaddingInlineStart = "12px";
export const utrechtButtonRvoSmPaddingInlineEnd = "12px";
export const utrechtButtonRvoSmMinBlockSize = "30px";
export const utrechtButtonRvoMdFontSize = "1.125rem";
export const utrechtButtonRvoMdPaddingBlockStart = "8px";
export const utrechtButtonRvoMdPaddingBlockEnd = "8px";
export const utrechtButtonRvoMdPaddingInlineStart = "16px";
export const utrechtButtonRvoMdPaddingInlineEnd = "16px";
export const utrechtButtonBorderWidth = "0";
export const utrechtButtonFontSize = "1.125rem";
export const utrechtButtonLineHeight = "24px";
export const utrechtButtonPaddingBlockStart = "8px";
export const utrechtButtonPaddingBlockEnd = "8px";
export const utrechtButtonPaddingInlineStart = "16px";
export const utrechtButtonPaddingInlineEnd = "16px";
export const utrechtButtonPrimaryActionBackgroundColor = "#007bc7";
export const utrechtButtonPrimaryActionColor = "#ffffff";
export const utrechtButtonPrimaryActionActiveBackgroundColor = "#01689b";
export const utrechtButtonPrimaryActionFocusBackgroundColor = "#007bc7";
export const utrechtButtonPrimaryActionHoverBackgroundColor = "#01689b";
export const utrechtButtonPrimaryActionDisabledBorderColor = "#e6e6e6";
export const utrechtButtonPrimaryActionDisabledBackgroundColor = "#e6e6e6";
export const utrechtButtonPrimaryActionDisabledColor = "#cccccc";
export const utrechtButtonPrimaryActionWarningBackgroundColor = "#d51b1e";
export const utrechtButtonPrimaryActionWarningBorderWidth = "0";
export const utrechtButtonPrimaryActionWarningColor = "#ffffff";
export const utrechtButtonPrimaryActionWarningActiveBackgroundColor = "#d51b1e";
export const utrechtButtonPrimaryActionWarningActiveColor = "#ffffff";
export const utrechtButtonPrimaryActionWarningFocusBackgroundColor = "#d51b1e";
export const utrechtButtonPrimaryActionWarningFocusColor = "#ffffff";
export const utrechtButtonPrimaryActionWarningHoverBackgroundColor = "#4d0a0b";
export const utrechtButtonPrimaryActionWarningHoverColor = "#ffffff";
export const utrechtButtonPrimaryActionWarningDisabledBorderColor = "#e6e6e6";
export const utrechtButtonPrimaryActionWarningDisabledBackgroundColor = "#e6e6e6";
export const utrechtButtonPrimaryActionWarningDisabledColor = "#cccccc";
export const utrechtButtonSecondaryActionBackgroundColor = "#ffffff";
export const utrechtButtonSecondaryActionBorderColor = "#007bc7";
export const utrechtButtonSecondaryActionBorderWidth = "1px";
export const utrechtButtonSecondaryActionColor = "#007bc7";
export const utrechtButtonSecondaryActionActiveBackgroundColor = "#01689b";
export const utrechtButtonSecondaryActionActiveBorderColor = "#01689b";
export const utrechtButtonSecondaryActionActiveColor = "#ffffff";
export const utrechtButtonSecondaryActionFocusColor = "#007bc7";
export const utrechtButtonSecondaryActionDisabledBackgroundColor = "#ffffff";
export const utrechtButtonSecondaryActionDisabledBorderColor = "#cccccc";
export const utrechtButtonSecondaryActionDisabledColor = "#cccccc";
export const utrechtButtonSecondaryActionHoverColor = "#01689b";
export const utrechtButtonSecondaryActionHoverBackgroundColor = "#ffffff";
export const utrechtButtonSecondaryActionHoverBorderColor = "#01689b";
export const utrechtButtonSubtleFontWeight = "700";
export const utrechtButtonSubtleActiveColor = "#4d0a0b";
export const utrechtButtonSubtleHoverTextDecoration = "underline";
export const utrechtButtonSubtleWarningBorderWidth = "0";
export const utrechtButtonSubtleWarningColor = "#d51b1e";
export const utrechtButtonSubtleWarningActiveColor = "#4d0a0b";
export const utrechtButtonSubtleWarningHoverColor = "#4d0a0b";
export const utrechtButtonSubtleWarningDisabledColor = "#cccccc";
export const utrechtButtonSubtleWarningFocusColor = "#d51b1e";
export const utrechtBlockquoteBackgroundColor = "#d9ebf7";
export const utrechtBlockquoteColor = "#000000";
export const utrechtBlockquoteMarginInlineStart = "0";
export const utrechtBlockquoteMarginInlineEnd = "0";
export const utrechtBlockquoteMarginBlockStart = "0";
export const utrechtBlockquoteMarginBlockEnd = "16px";
export const utrechtBlockquoteFontSize = "1rem";
export const utrechtBlockquoteFontStyle = "italic";
export const utrechtBlockquotePaddingBlockEnd = "16px";
export const utrechtBlockquotePaddingBlockStart = "16px";
export const utrechtBlockquotePaddingInlineStart = "32px";
export const utrechtBlockquotePaddingInlineEnd = "32px";
export const utrechtBreadcrumbFontSize = "0.875rem";
export const utrechtBreadcrumbItemGap = "8px";
export const utrechtBreadcrumbItemPaddingBlockStart = "0";
export const utrechtBreadcrumbItemPaddingBlockEnd = "0";
export const utrechtBreadcrumbItemPaddingInlineEnd = "0";
export const utrechtBreadcrumbItemPaddingInlineStart = "0";
export const utrechtBreadcrumbLinkColor = "#007bc7";
export const utrechtBreadcrumbLinkFocusBackgroundColor = "#d9ebf7";
export const utrechtBreadcrumbLinkFocusColor = "#000000";
export const utrechtBreadcrumbLinkFocusTextDecoration = "underline";
export const utrechtBreadcrumbLinkFocusTextDecorationThickness = "3px";
export const utrechtBreadcrumbLinkHoverTextDecoration = "underline";
export const utrechtBreadcrumbLinkHoverTextDecorationThickness = "2px";
export const utrechtBreadcrumbLinkTextDecoration = "none";
export const utrechtCustomRadioButtonSize = "24px";
export const utrechtCustomRadioButtonBorderColor = "#000000";
export const utrechtCustomRadioButtonColor = "#000000";
export const utrechtCustomRadioButtonBorderWidth = "2px";
export const utrechtCustomRadioButtonBackgroundColor = "#ffffff";
export const utrechtCustomRadioButtonBorderRadius = "0";
export const utrechtCustomRadioButtonIconSize = "16px";
export const utrechtCustomRadioButtonActiveBorderColor = "#000000";
export const utrechtCustomRadioButtonActiveBorderWidth = "2px";
export const utrechtCustomRadioButtonActiveBackgroundColor = "#ffffff";
export const utrechtCustomRadioButtonActiveColor = "#000000";
export const utrechtCustomRadioButtonDisabledBorderColor = "#cccccc";
export const utrechtCustomRadioButtonDisabledBackgroundColor = "#ffffff";
export const utrechtCustomRadioButtonCheckedBorderColor = "#000000";
export const utrechtCustomRadioButtonCheckedBorderWidth = "2px";
export const utrechtDataListBorderColor = "#b4b4b4";
export const utrechtDataListBorderWidth = "1px";
export const utrechtDataListMarginBlockEnd = "0";
export const utrechtDataListMarginBlockStart = "0";
export const utrechtDataListItemKeyBorderInlineEndColor = "#b4b4b4";
export const utrechtDataListItemKeyBorderInlineEndWidth = "1px";
export const utrechtDataListItemKeyFontWeight = "700";
export const utrechtDataListItemKeyPaddingBlockEnd = "8px";
export const utrechtDataListItemKeyPaddingBlockStart = "8px";
export const utrechtDataListItemKeyPaddingInlineEnd = "16px";
export const utrechtDataListItemKeyPaddingInlineStart = "16px";
export const utrechtDataListItemValuePaddingBlockEnd = "8px";
export const utrechtDataListItemValuePaddingBlockStart = "8px";
export const utrechtDataListItemValuePaddingInlineEnd = "16px";
export const utrechtDataListItemValuePaddingInlineStart = "16px";
export const utrechtDataListRowsBorderBottomColor = "#b4b4b4";
export const utrechtDataListRowsBorderBottomWidth = "1px";
export const utrechtDataListRowsItemMarginBlockStart = "0";
export const utrechtDataListRowsItemPaddingInlineStart = "12px";
export const utrechtDataListRowsItemValueMarginBlockStart = "0";
export const utrechtDataListRowsColumnInlineSize = "50%";
export const utrechtDataListRowsColumnMinInlineSize = "25ch";
export const utrechtDocumentBackgroundColor = "transparent";
export const utrechtDocumentColor = "#000000";
export const utrechtDocumentFontFamily = "'RijksoverheidSansWebText'";
export const utrechtDocumentFontSize = "1rem";
export const utrechtDocumentFontWeight = "400";
export const utrechtDocumentLineHeight = "150%";
export const utrechtFormFieldDescriptionMarginBlockStart = "0";
export const utrechtFormFieldDescriptionMarginBlockEnd = "0";
export const utrechtFormFieldLabelMarginBlockStart = "0";
export const utrechtFormFieldLabelMarginBlockEnd = "0";
export const utrechtFormFieldMarginBlockEnd = "24px";
export const utrechtFormFieldsetMarginBlockEnd = "0";
export const utrechtFormFieldsetMarginBlockStart = "0";
export const utrechtFormFieldsetSectionBackgroundColor = "#f3f3f3";
export const utrechtFormFieldsetPaddingBlockEnd = "24px";
export const utrechtFormFieldsetPaddingBlockStart = "18px";
export const utrechtFormFieldsetPaddingInlineEnd = "24px";
export const utrechtFormFieldsetPaddingInlineStart = "24px";
export const utrechtFormFieldsetLegendFontSize = "1.25rem";
export const utrechtFormFieldsetLegendFontWeight = "700";
export const utrechtFormFieldsetLegendLineHeight = "150%";
export const utrechtFormFieldsetLegendMarginBlockEnd = "24px";
export const utrechtFormInputBackgroundColor = "#ffffff";
export const utrechtFormInputBorderColor = "#000000";
export const utrechtFormInputBorderRadius = "0";
export const utrechtFormInputBorderWidth = "2px";
export const utrechtFormInputColor = "#000000";
export const utrechtFormInputFontSize = "1rem";
export const utrechtFormInputPaddingBlockEnd = "8px";
export const utrechtFormInputPaddingBlockStart = "12px";
export const utrechtFormInputPaddingInlineEnd = "12px";
export const utrechtFormInputPaddingInlineStart = "12px";
export const utrechtFormInputDisabledBackgroundColor = "#cccccc !important";
export const utrechtFormInputDisabledBorderColor = "#535353";
export const utrechtFormInputDisabledBorderWidth = "2px";
export const utrechtFormInputDisabledColor = "#535353";
export const utrechtFormInputFocusBackgroundColor = "#ffffff";
export const utrechtFormInputFocusBorderColor = "#000000";
export const utrechtFormInputInvalidBackgroundColor = "#ffffff";
export const utrechtFormInputInvalidBorderColor = "#d51b1e";
export const utrechtFormInputInvalidBorderWidth = "2px";
export const utrechtFormInputReadOnlyBorderColor = "#535353";
export const utrechtFormInputReadOnlyColor = "#535353";
export const utrechtFormLabelFontWeight = "700";
export const utrechtFormLabelFontSize = "16px";
export const utrechtFormLabelRadioFontWeight = "400";
export const utrechtHeading1FontSize = "2rem";
export const utrechtHeading1FontWeight = "700";
export const utrechtHeading1LineHeight = "175%";
export const utrechtHeading1MarginBlockEnd = "16px";
export const utrechtHeading1MarginBlockStart = "16px";
export const utrechtHeading2FontSize = "1.5rem";
export const utrechtHeading2FontWeight = "700";
export const utrechtHeading2LineHeight = "150%";
export const utrechtHeading2MarginBlockEnd = "4px";
export const utrechtHeading3FontSize = "1.25rem";
export const utrechtHeading3FontWeight = "700";
export const utrechtHeading3LineHeight = "125%";
export const utrechtHeading3MarginBlockEnd = "4px";
export const utrechtHeading4FontSize = "1.125rem";
export const utrechtHeading4FontWeight = "700";
export const utrechtHeading4MarginBlockEnd = "4px";
export const utrechtHeading5FontSize = "1rem";
export const utrechtHeading5FontWeight = "700";
export const utrechtHeading5MarginBlockEnd = "4px";
export const utrechtHeading6FontSize = "0.875rem";
export const utrechtHeading6FontWeight = "700";
export const utrechtHeading6MarginBlockEnd = "4px";
export const utrechtLinkColor = "#007bc7";
export const utrechtLinkTextDecoration = "underline";
export const utrechtLinkTextDecorationThickness = "1px";
export const utrechtLinkTextUnderlineOffset = "2px";
export const utrechtLinkActiveTextDecorationThickness = "3px";
export const utrechtLinkFocusBackgroundColor = "#d9ebf7";
export const utrechtLinkFocusColor = "#000000";
export const utrechtLinkFocusTextDecoration = "underline";
export const utrechtLinkFocusTextDecorationThickness = "3px";
export const utrechtLinkHoverColor = "#01689b";
export const utrechtLinkHoverTextDecoration = "underline";
export const utrechtLinkHoverTextDecorationThickness = "2px";
export const utrechtOrderedListMarginBlockEnd = "16px";
export const utrechtOrderedListItemPaddingInlineStart = "0";
export const utrechtOrderedListPaddingInlineStart = "0";
export const utrechtPageFooterBackgroundColor = "#154273";
export const utrechtPageFooterColor = "#ffffff";
export const utrechtPageFooterPaddingInlineEnd = "18px";
export const utrechtPageFooterPaddingInlineStart = "18px";
export const utrechtParagraphFontSize = "1rem";
export const utrechtParagraphLineHeight = "150%";
export const utrechtParagraphMarginBlockEnd = "16px";
export const utrechtParagraphLeadFontSize = "1.125rem";
export const utrechtParagraphLeadLineHeight = "150%";
export const utrechtParagraphSmallFontSize = "0.875rem";
export const utrechtParagraphSmallLineHeight = "150%";
export const utrechtTableFontSize = "1rem";
export const utrechtTableHeaderBackgroundColor = "#f3f3f3";
export const utrechtTableHeaderColor = "#535353";
export const utrechtTableHeaderCellFontSize = "700";
export const utrechtTableCellLineHeight = "20px";
export const utrechtTableCellPaddingBlockEnd = "8px";
export const utrechtTableCellPaddingBlockStart = "8px";
export const utrechtTableCellPaddingInlineEnd = "16px";
export const utrechtTableCellPaddingInlineStart = "16px";
export const utrechtTableRowBorderBlockEndColor = "#f3f3f3";
export const utrechtTableRowBorderBlockEndWidth = "1px";
export const utrechtTextareaMinBlockSize = "96px";
export const utrechtTopnavListBackgroundColor = "#007bc7";
export const utrechtTopnavLinkColor = "#ffffff";
export const utrechtTopnavLinkBackgroundColor = "#007bc7";
export const utrechtUnorderedListMarginBlockStart = "0";
export const utrechtUnorderedListMarginBlockEnd = "16px";
export const utrechtUnorderedListItemPaddingInlineStart = "0";
export const utrechtUnorderedListItemMarker = "initial";
export const utrechtUnorderedListPaddingInlineStart = "22px";
export const utrechtUnorderedListListStyleType = "disc";